<template>
  <div :class="['ms-form', 'ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-linear-progress v-if="this.isFetching" indeterminate/>
    <q-form v-else @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomSelect
          :options="this.assignTypes"
          label="Тип назначения"
          optionValueKey="assign_type_id"
          :loading="this.isFetching"
          optionLabelKey="assign_type_name"
          :value="this.formData.assign_type_id || ''"
          @change="this.handleAssignTypeChange"
          :clearable="true"
          :required="true"
        />
        <CustomSelect
          :options="this.contractorsOptions"
          label="Компания"
          optionValueKey="contractor_id"
          optionLabelKey="contractor_name"
          :value="this.formData.contractor_id || ''"
          @change="(value) => this.handleContractorChange(value)"
          :clearable="true"
          :required="contractorsOptionsRequired"
        />
        <CustomSelect
          v-if="this.shouldShowEmployeeField"
          :options="this.employeesOptions"
          label="Сотрудник"
          optionValueKey="employee_id"
          optionLabelKey="fio"
          :value="this.formData.employee_id || ''"
          @change="(value) => this.handleEmployeeChange(value)"
          :clearable="true"
          :required="true"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import {
  getAssignTypes,
  getContractorsList,
  getEmployeesListByContractorId,
} from "@/views/ShellProjects/services";

export default {
  name: "upd-shl-project-perfomancer",
  components: { CustomInput, CustomSelect, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      isFetching: false,
      assignTypes: [],
      contractorsOptions: [],
      employeesOptions: [],
      assignTypeCode: this.data?.body.assign_type_code || "",
      formData: {
        project_id: this.data?.body.project_id || "",
        project_assign_id: this.data?.body.project_assign_id || "",
        assign_type_id: this.data?.body.assign_type_id || "",
        contractor_id: this.data?.body.contractor_id || "",
        employee_id: this.data?.body.employee_id || "",
      }
    };
  },

  computed: {
    shouldShowEmployeeField() {
      return this.assignTypeCode !== 'PSD_CONTRACTOR';
    },
    contractorsOptionsRequired() {
      return this.assignTypeCode !== 'OBSERVER';
    }
  },

  async mounted() {
    await this.initializeForm();
  },

  methods: {
    async initializeForm() {
      this.isFetching = true

      await Promise.all([
        this.loadAssignTypes(),
        this.loadContractors()
      ]);

      if(this.data?.body.assign_type_code !== 'PSD_CONTRACTOR') {
        await this.loadEmployees(this.data?.body.assign_type_code === 'OBSERVER' && !this.data?.body.contractor_id ? '0' : this.data?.body.contractor_id, true);
      }

      this.isFetching = false
    },

    async loadAssignTypes() {
      const res = await getAssignTypes();
      this.assignTypes = res || [];
    },

    async loadContractors() {
      const res = await getContractorsList();
      this.contractorsOptions = res || [];
    },

    async loadEmployees(contractorId, isMount = false) {
      const id = contractorId || 0;

      const res = await getEmployeesListByContractorId(id);
      this.employeesOptions = res || [];
      if(isMount && this.data?.body?.employee_id && !this.employeesOptions?.length) {
        this.employeesOptions = [{employee_id: this.data?.body?.employee_id, fio: this.data?.body?.employee_fio}];
      }
    },

    async handleAssignTypeChange(value, row) {
      this.isFetching = true

      this.formData.assign_type_id = value;
      this.assignTypeCode = row?.assign_type_code || '';
      
      this.formData.contractor_id = "";
      this.formData.employee_id = "";

      if (value === 4) {
        await this.loadEmployees("0");
      }
      this.isFetching = false
    },

    async handleContractorChange(value) {
      this.isFetching = true

      this.formData.contractor_id = value;
      this.formData.employee_id = "";
      
      await this.loadEmployees(value);
      this.isFetching = false
    },

    handleEmployeeChange(value) {
      this.formData.employee_id = value;
    },

    async onSubmit() {
      const {assign_type_id, employee_id, contractor_id} = this.formData
      if (assign_type_id == "" && employee_id == "" && contractor_id == "") {
        return;
      }

      this.loading = true;
      const submitData = { ...this.formData };

      if (this.assignTypeCode === 'PSD_CONTRACTOR') {
        delete submitData.employee_id;
      }

      await this.data?.onSubmit(submitData);
      this.loading = false;
    },
  },
};
</script>